import React from "react";
import SidebarBase from "./SidebarBase";
export default function SidebarAdministracion() {
  return (
    <SidebarBase
      storageKeyMenus="operacion_menus"
      storageKeySubmenu="submenu_ope"
      storageKeyLoc="submenu_loc_ope"
      storageKeyName="submenu_name_ope"
    />
  );
}
